(function (angular, document) {
  "use strict";

  var BUFFER_FULL_PERCENT = 100;

  angular.module("Toyota.Directives").directive("tyJwplayer", [
    "GenerateUuid",
    "$window",
    "DebugLogger",
    "$timeout",
    "$rootScope",
    "CssMediaWatcher",
    "GlobalBreakpoints",
    "SitecoreAnalytics",
    "ParseBool",
    function (
      GenerateUuid,
      $window,
      DebugLogger,
      $timeout,
      $rootScope,
      CssMediaWatcher,
      GlobalBreakpoints,
      SitecoreAnalytics,
      ParseBool
    ) {
      var debugOverlay = false;

      // For aspectRatioSource === 'video', see https://dashboard.jwplayer.com/ -> Publish -> Players -> Player Size (16:9 since inception)

      var baseSettingsSets = {
        "default": {
          hideWhenMediaIs: null,
          useMobileSrcWhenMediaIs: "sm-",
          srcRespondsTo: "viewportWidth",
          hideOnError: false,
        },
        "silent-loop-fill-viewport": {
          autoplay: true,
          aspectRatioSource: "css",
          extraCssClasses: "-fill-viewport",
          showControls: false,
          mute: true,
          repeat: "precise",
        },
        "silent-loop-fill-container": {
          autoplay: true,
          aspectRatioSource: "css",
          extraCssClasses: "-fill-container",
          showControls: false,
          mute: true,
          repeat: "precise",
        },
        "silent-play-once-fill-container": {
          autoplay: true,
          aspectRatioSource: "css",
          extraCssClasses: "-fill-container",
          showControls: false,
          mute: true,
          repeat: false,
        },
        "silent-play-once-every-scroll-fill-container": {
          autoplay: true,
          aspectRatioSource: "css",
          extraCssClasses: "-fill-container",
          showControls: false,
          mute: true,
          repeat: "every-scroll",
        },
        "silent-loop-16-9": {
          autoplay: true,
          aspectRatioSource: "css",
          extraCssClasses: "-fill-container",
          showControls: false,
          mute: true,
          repeat: "precise",
        },
        "longform-16-9": {
          autoplay: false,
          aspectRatioSource: "css",
          extraCssClasses: "-fill-container",
          showControls: true,
          mute: false,
          repeat: false,
        },
        "silent-play-once-16-9": {
          autoplay: true,
          aspectRatioSource: "css",
          extraCssClasses: "-fill-container",
          showControls: false,
          mute: true,
          repeat: false,
        },
        "silent-play-once-every-scroll-16-9": {
          autoplay: true,
          aspectRatioSource: "css",
          extraCssClasses: "-fill-container",
          showControls: false,
          mute: true,
          repeat: "every-scroll",
        },
        "silent-play-once-fill-viewport": {
          autoplay: true,
          aspectRatioSource: "css",
          extraCssClasses: "-fill-viewport",
          showControls: false,
          mute: true,
          repeat: false,
        },
        "silent-play-once-every-scroll-fill-viewport": {
          autoplay: true,
          aspectRatioSource: "css",
          extraCssClasses: "-fill-viewport",
          showControls: false,
          mute: true,
          repeat: "every-scroll",
        },
      };

      // All base settings sets to "inherit" from default
      for (var key in baseSettingsSets) {
        if (Object.prototype.hasOwnProperty.call(baseSettingsSets, key) && key !== "default") {
          var replacement = angular.copy(baseSettingsSets.default);
          var set = baseSettingsSets[key];
          angular.extend(replacement, set);
          baseSettingsSets[key] = replacement;
        }
      }

      function parseBoolFallbackToSelf(value) {
        var bool = ParseBool(value, undefined);
        return typeof bool !== "undefined" ? bool : value;
      }

      return {
        restrict: "E",
        replace: true, // yes, this actually merges the class attribute intelligently
        scope: {
          videoSrcLandscapeOrDesktop: "@?videoSrcLandscapeOrDesktop",
          videoSrcPortraitOrMobile: "@?videoSrcPortraitOrMobile",
          srcRespondsTo: "@?srcRespondsTo",
          orientationSensorCssClass: "@?orientationSensorCssClass",
          imageSrc: "@?imageSrc",
          baseSettings: "@?baseSettings",
          aspectRatioSource: "@?aspectRatioSource",
          extraCssClasses: "@?extraCssClasses",
          showControls: "@?showControls",
          mute: "@?mute",
          autoplay: "@?autoplay",
          repeat: "@?repeat",
          hideWhenMediaIs: "@?hideWhenMediaIs",
          useMobileSrcWhenMediaIs: "@?useMobileSrcWhenMediaIs",
          hideOnError: "@?hideOnError",
          videoPlayGoalId: "@videoPlayGoalId",
          videoCompleteGoalId: "@videoCompleteGoalId",
        },
        transclude: true,
        // prettier-ignore
        template:
          '<div class="ty-jwplayer" ' +
            'data-ng-show="!internal.hideAndDontLoadVideo && !(internal.hideOnError && internal.error)" ' +
            'data-ng-class="[' +
              "{" +
                "'-use-video-size': internal.aspectRatioSource !== 'css'" +
              "}," +
              "internal.extraCssClasses || ''" +
            ']"' +
          ">" +
            '<span class="ty-jwplayer__loading-spinner" data-jwplayer-loading-spinner><ty-loading-spinner large bright></ty-loading-spinner></span>' +
            '<div class="ty-jwplayer__container" data-set-background-image>' +
              "<div data-jwplayer-placeholder></div>" +
            "</div>" +
            '<div class="ty-jwplayer__foreground">' +
              "<div data-ng-transclude-replace></div>" +
            "</div>" +
            '<div class="ty-jwplayer__error" data-ng-show="internal.error">' +
              '<ty-svg-icon icon-id="alert-info"></ty-svg-icon>' +
              "<p>Error loading media.</p>" +
            "</div>" +
            (debugOverlay ? '<div class="ty-jwplayer__debug-overlay">{{internal.playerInfo.state}}</div>' : "") +
          "</div>",
        link: function ($scope, $element) {
          var $placeholder = $element.find("[data-jwplayer-placeholder]");

          /*
           * SIR-1223 - Separate public scope (bound to HTML attributes, from which "internal" scope derives) from
           * internal scope, because mutated scope was being clobbered by AngularJS doing some unexpected binding
           * between when link() completes and when JWPlayer's ready event fires
           */
          $scope.internal = {};

          /*
           * 1. Use the 'baseSettings' attribute to pick up default settings
           * 2. Where attributes are present, override the defaults
           * 3. Apply the final config to $scope
           */
          $scope.internal.baseSettings = $scope.baseSettings || "longform-16-9";

          var defaultConfigValues = baseSettingsSets[$scope.internal.baseSettings];

          $scope.internal = angular.copy(defaultConfigValues);

          $scope.internal.videoSrcLandscapeOrDesktop = $scope.videoSrcLandscapeOrDesktop;
          $scope.internal.videoSrcPortraitOrMobile = $scope.videoSrcPortraitOrMobile;
          $scope.internal.imageSrc = $scope.imageSrc;

          $scope.internal.aspectRatioSource = $scope.aspectRatioSource || defaultConfigValues.aspectRatioSource;
          $scope.internal.extraCssClasses = $scope.extraCssClasses || defaultConfigValues.extraCssClasses;
          $scope.internal.showControls = $scope.showControls
            ? ParseBool($scope.showControls, defaultConfigValues.showControls)
            : defaultConfigValues.showControls;
          $scope.internal.mute = $scope.mute
            ? ParseBool($scope.mute, defaultConfigValues.mute)
            : defaultConfigValues.mute;
          $scope.internal.autoplay = $scope.autoplay
            ? ParseBool($scope.autoplay, defaultConfigValues.autoplay)
            : defaultConfigValues.autoplay;
          $scope.internal.repeat = $scope.repeat ? parseBoolFallbackToSelf($scope.repeat) : defaultConfigValues.repeat;
          $scope.internal.hideWhenMediaIs = $scope.hideWhenMediaIs
            ? parseBoolFallbackToSelf($scope.hideWhenMediaIs)
            : defaultConfigValues.hideWhenMediaIs;
          $scope.internal.srcRespondsTo = $scope.srcRespondsTo || defaultConfigValues.srcRespondsTo;
          $scope.internal.orientationSensorCssClass =
            $scope.orientationSensorCssClass || defaultConfigValues.orientationSensorCssClass;
          $scope.internal.useMobileSrcWhenMediaIs =
            $scope.useMobileSrcWhenMediaIs || defaultConfigValues.useMobileSrcWhenMediaIs;
          $scope.internal.hideOnError = $scope.hideOnError
            ? ParseBool($scope.hideOnError, defaultConfigValues.hideOnError)
            : defaultConfigValues.hideOnError;

          var playerInstance;

          $scope.internal.playerInfo = {
            state: null,
          };

          var elVideo;

          /*
           * https://www.gizmodo.com.au/2016/06/the-state-of-4g-in-australia-telstra-is-fastest-but-vodafone-wins-out-on-availability/
           * 3G --> 3.95-4.76 Mbps
           * 4G --> 18.5-23.6 Mbps
           */

          var oldShouldVideoBePlaying = false;
          var isParentVisible = true;

          var getIsInsideModal = function () {
            return !!$element.closest("[data-ty-modal]").length;
          };

          var getParentModalScrollAreaElement = function () {
            return $element.closest("[data-ty-modal-scroll-area]");
          };

          var getParentModalScrollAreaRect = function () {
            return getParentModalScrollAreaElement().get(0).getBoundingClientRect();
          };

          // intersect here excludes bottom/rightmost pixels so you can have an 0px width/height rect
          var areRectsIntersecting = function (rect1, rect2) {
            return (
              rect1.left < rect2.right &&
              rect2.left < rect1.right &&
              rect1.top < rect2.bottom &&
              rect2.top < rect1.bottom
            );
          };

          var getViewportRect = function () {
            return {
              left: 0,
              top: 0,
              right: document.body.clientWidth,
              bottom: $window.innerHeight,
            };
          };

          var isVideoIntersectingViewportWithTolerance = function (horizTolerance, vertTolerance, viewportRect) {
            var rect = elVideo.getBoundingClientRect();

            if (rect.right - rect.left === 0 || rect.bottom - rect.top === 0) {
              return false;
            }

            return areRectsIntersecting(
              {
                left: viewportRect.left - horizTolerance,
                top: viewportRect.top - vertTolerance,
                right: viewportRect.right + horizTolerance,
                bottom: viewportRect.bottom + vertTolerance,
              },
              rect
            );
          };

          var getIsVideoNearViewport = function (viewportRect) {
            var windowHeight = $window.innerHeight;
            var windowWidth = document.body.clientWidth;
            var horizTolerance = windowWidth / 2;
            var vertTolerance = windowHeight / 2;
            return isVideoIntersectingViewportWithTolerance(horizTolerance, vertTolerance, viewportRect);
          };

          var getIsVideoInViewport = function (viewportRect) {
            return isVideoIntersectingViewportWithTolerance(0, 0, viewportRect);
          };

          var updateJwPlayerPlaybackState = function () {
            if (!elVideo) {
              DebugLogger.log(
                "JWPlayer",
                $scope.internal.debugId +
                  " updateJwPlayerPlaybackState: video element doesn't even exist, nothing to do here"
              );
              return;
            }

            if (!$scope.internal.autoplay) {
              DebugLogger.log(
                "JWPlayer",
                $scope.internal.debugId + " updateJwPlayerPlaybackState: video is not autoplay, nothing to do here"
              );
              return;
            }

            var state = playerInstance.getState();

            if (!$scope.internal.repeat && state === "complete") {
              DebugLogger.log(
                "JWPlayer",
                $scope.internal.debugId +
                  " updateJwPlayerPlaybackState: this video never repeats and state is complete, nothing to do here"
              );
              return;
            }

            if (state === "idle" && $scope.internal.repeat === "every-scroll") {
              DebugLogger.log(
                "JWPlayer",
                $scope.internal.debugId +
                  " updateJwPlayerPlaybackState: idle and starting again " +
                  playerInstance.getPosition()
              );
              playerInstance.play();
            }

            var viewportRect = getIsInsideModal() ? getParentModalScrollAreaRect() : getViewportRect();

            var isVideoReady = playerInstance.getBuffer() === BUFFER_FULL_PERCENT;
            var isVideoInViewport = isParentVisible && getIsVideoInViewport(viewportRect);
            var isVideoNearViewport = isParentVisible && getIsVideoNearViewport(viewportRect);

            /*
             * A video not yet fully loaded should begin playback a little early, so it's already playing
             * by the time scrolls to it
             */
            var shouldVideoBePlaying = isVideoReady ? isVideoInViewport : isVideoNearViewport;

            var didShouldVideoBePlayingChange = oldShouldVideoBePlaying !== shouldVideoBePlaying;
            var shouldVideoPlay = didShouldVideoBePlayingChange && shouldVideoBePlaying;
            var shouldVideoPause = didShouldVideoBePlayingChange && !shouldVideoBePlaying;

            if (shouldVideoPlay) {
              DebugLogger.log(
                "JWPlayer",
                $scope.internal.debugId + " updateJwPlayerPlaybackState: video entered playback rectangle"
              );
              if ($scope.internal.repeat === "every-scroll") {
                DebugLogger.log(
                  "JWPlayer",
                  $scope.internal.debugId + " updateJwPlayerPlaybackState: stopped at " + playerInstance.getPosition()
                );
                playerInstance.stop();
              }

              DebugLogger.log(
                "JWPlayer",
                $scope.internal.debugId + " updateJwPlayerPlaybackState: playing from " + playerInstance.getPosition()
              );
              playerInstance.play();
            }

            if (shouldVideoPause) {
              DebugLogger.log(
                "JWPlayer",
                $scope.internal.debugId + " updateJwPlayerPlaybackState: video exited playback rectangle"
              );
              DebugLogger.log(
                "JWPlayer",
                $scope.internal.debugId + " updateJwPlayerPlaybackState: paused at " + playerInstance.getPosition()
              );
              playerInstance.pause();
            }

            oldShouldVideoBePlaying = shouldVideoBePlaying;
          };

          var replaceLoaderIcon = function () {
            var $oldIcon = $element.find(".jw-svg-icon-buffer");
            $oldIcon.after($element.find("[data-jwplayer-loading-spinner]"));
            $oldIcon.remove();
          };

          var setVideoSrcInUse = function (videoSrcInUse) {
            $scope.internal.videoSrcInUse = videoSrcInUse;
            $scope.internal.debugId = videoSrcInUse.match(/[^/]+$/)[0];
          };

          var ensureElementExistsWithCssClass = function (cssClass) {
            var el = document.querySelector(`.${cssClass}`);
            if (!el) {
              el = document.createElement("div");
              el.className = cssClass;
              document.body.appendChild(el);
            }

            return el;
          };

          /*
           * Watch viewportWidth and orientation as needed
           */

          var getCssMediaWatcherConfig = function () {
            var hideWhenMediaIs = GlobalBreakpoints.parseCompoundExpression($scope.internal.hideWhenMediaIs);
            var useMobileSrcWhenMediaIs = GlobalBreakpoints.parseCompoundExpression(
              $scope.internal.useMobileSrcWhenMediaIs
            );

            var mediaWatcherConfig = [];

            /*
             * Note that srcRespondsTo corresponds to a value of mediaProperty, that is valid attribute values are:
             * - data-src-responds-to="viewportWidth"
             * - data-src-responds-to="orientation"
             *
             */
            mediaWatcherConfig.push({
              $el: angular.element(".ty-global-breakpoint-sensor"),
              pseudoEl: "before",
              mediaProperty: "viewportWidth",
              mediaRegexes: {
                hideAndDontLoadVideo: hideWhenMediaIs ? "^(" + hideWhenMediaIs.join("|") + ")$" : null,
                useMobileSrc: useMobileSrcWhenMediaIs ? "^(" + useMobileSrcWhenMediaIs.join("|") + ")$" : null,
              },
            });

            if ($scope.internal.srcRespondsTo === "orientation") {
              var orientationSensor = ensureElementExistsWithCssClass($scope.internal.orientationSensorCssClass);

              mediaWatcherConfig.push({
                $el: angular.element(orientationSensor),
                pseudoEl: "before",
                mediaProperty: "orientation",
                mediaRegexes: {
                  useMobileSrc: "^portrait$",
                },
              });
            }

            return mediaWatcherConfig;
          };

          var init = function () {
            $element.removeAttr("href"); // "replace: true" doesn't do what you think it does -- let's fix that

            $scope.internal.hasMultipleVideoSrc =
              $scope.internal.videoSrcLandscapeOrDesktop &&
              $scope.internal.videoSrcPortraitOrMobile &&
              $scope.internal.videoSrcLandscapeOrDesktop !== $scope.internal.videoSrcPortraitOrMobile;
            $scope.internal.isSrcResponsive = $scope.internal.hasMultipleVideoSrc;
            $scope.internal.hideAndDontLoadVideo = false;

            var viewportWidthCssMediaWatcher = CssMediaWatcher(getCssMediaWatcherConfig());

            viewportWidthCssMediaWatcher.on("didInit", function (e, cssMedia) {
              if ($scope.internal.hasMultipleVideoSrc) {
                setVideoSrcInUse(
                  cssMedia[$scope.internal.srcRespondsTo].is.useMobileSrc
                    ? $scope.internal.videoSrcPortraitOrMobile
                    : $scope.internal.videoSrcLandscapeOrDesktop
                );
              }

              $scope.internal.hideAndDontLoadVideo =
                viewportWidthCssMediaWatcher.getCurrentMedia().viewportWidth.is.hideAndDontLoadVideo;
            });

            viewportWidthCssMediaWatcher.on("didChange", function (e, cssMedia) {
              if ($scope.internal.isSrcResponsive) {
                setVideoSrcInUse(
                  cssMedia[$scope.internal.srcRespondsTo].is.useMobileSrc
                    ? $scope.internal.videoSrcPortraitOrMobile
                    : $scope.internal.videoSrcLandscapeOrDesktop
                );
                $scope.internal.hideAndDontLoadVideo =
                  viewportWidthCssMediaWatcher.getCurrentMedia().viewportWidth.is.hideAndDontLoadVideo;
              }
            });

            if (!$scope.internal.hasMultipleVideoSrc) {
              setVideoSrcInUse($scope.internal.videoSrcLandscapeOrDesktop || $scope.internal.videoSrcPortraitOrMobile);
            }

            /*
             * Continue playing from current playhead position if src is changed
             */

            $scope.$watch("internal.videoSrcInUse", function (newVideoSrcInUse, oldVideoSrcInUse) {
              if (newVideoSrcInUse === oldVideoSrcInUse) {
                return;
              }

              if ($scope.internal.hideAndDontLoadVideo) {
                return;
              }

              var wasPlaying =
                playerInstance.getState() === "playing";
              var seekPosition = playerInstance.getPosition();

              playerInstance.once("firstFrame", function () {
                playerInstance.seek(seekPosition);
              });

              playerInstance.load([{ file: $scope.internal.videoSrcInUse }]);

              if (wasPlaying) {
                playerInstance.play();
              }
            });

            /*
             * We're combining JWPlayer's "image" property with CSS on the container
             * so that there's no black frame between preview and playback
             */

            $element
              .find("[data-set-background-image]")
              .css("background-image", 'url("' + $scope.internal.imageSrc + '")');

            $placeholder.attr("id", "jwplayer-" + GenerateUuid());
            playerInstance = window.jwplayer($placeholder.attr("id")).setup({
              autostart: false,
              controls: $scope.internal.showControls,
              image: $scope.internal.imageSrc,
              file: $scope.internal.videoSrcInUse,
              mute: $scope.internal.mute,
              repeat: false, // unfortunately shows a black frame for a short duration between loops
              stretching: "fill",
              height: "100%",
              width: "100%",
            });

            /*
             * Cinemagraphs need to circumvent JWPlayer's janky looping
             * and use the smoother native HTML5 video looping
             */

            /*
             * We are assuming cinemagraphs will never be streamed, so
             * we're fairly safe to assume a vanilla HTML5 video element
             */

            playerInstance.on("ready", function () {
              DebugLogger.log("JWPlayer", $scope.internal.debugId + " ready");

              elVideo = playerInstance.getContainer().querySelector("video");

              if ($scope.internal.repeat === "precise") {
                DebugLogger.log("JWPlayer", $scope.internal.debugId + " ready -> this will use precise repeat");
                elVideo.loop = true;
              }

              if ($scope.internal.hideAndDontLoadVideo) {
                DebugLogger.log(
                  "JWPlayer",
                  $scope.internal.debugId + " ignoring video (hideAndDontLoadVideo breakpoint is active)"
                );
                return;
              }

              updateJwPlayerPlaybackState();
            });

            playerInstance.on("buffer", function () {
              replaceLoaderIcon();
            });

            /*
             * Other video - loop without exposing black frames at the
             * loop boundary, by seeking to 0s about 1 sec before the
             * video ends (0.5sec is not always reliable)
             */

            if ($scope.internal.repeat === "seek-to-zero-early") {
              var videoDuration;

              playerInstance.on("play", function () {
                videoDuration = playerInstance.getDuration();
              });

              playerInstance.on("time", function (e) {
                if (e.position >= videoDuration - 1) {
                  playerInstance.seek(0);
                }
              });
            }

            if (!$scope.internal.autoplay) {
              playerInstance.on("play", function () {
                if ($scope.videoPlayGoalId) {
                  SitecoreAnalytics.triggerGoal($scope.videoPlayGoalId);
                }
              });

              playerInstance.on("complete", function () {
                if ($scope.videoCompleteGoalId) {
                  SitecoreAnalytics.triggerGoal($scope.videoCompleteGoalId);
                }
              });
            }

            angular.element($window).on("scroll resize", function () {
              updateJwPlayerPlaybackState();
            });

            if (getIsInsideModal()) {
              var thisModalId = $element.closest("[data-ty-modal]").isolateScope().ctl.modalId;
              var $parentModalScrollArea = getParentModalScrollAreaElement();

              isParentVisible = false;

              $scope.$on("will-modal-open", function (event, modalId) {
                if (thisModalId !== modalId) {
                  return;
                }

                DebugLogger.log(
                  "JWPlayer",
                  $scope.internal.debugId + " modal-open listener -> about to update playback state"
                );

                isParentVisible = true;
                updateJwPlayerPlaybackState();
              });

              $scope.$on("did-modal-close", function (event, modalId) {
                if (thisModalId !== modalId) {
                  return;
                }

                isParentVisible = false;

                DebugLogger.log(
                  "JWPlayer",
                  $scope.internal.debugId +
                    " modal-close listener -> transition finished, about to update playback state"
                );

                // Effectively resets "play-once" state on modal-close
                if ($scope.internal.repeat === false) {
                  DebugLogger.log(
                    "JWPlayer",
                    $scope.internal.debugId + " modal-close listener -> stopping at " + playerInstance.getPosition()
                  );
                }

                playerInstance.stop();
                updateJwPlayerPlaybackState();
              });

              $parentModalScrollArea.on("scroll", function () {
                updateJwPlayerPlaybackState();
              });
            }

            $rootScope.$on("owl-carousel-slide-change-end", function () {
              updateJwPlayerPlaybackState();
            });
            $rootScope.$on("accordion-close", function (event, item) {
              var parentNode = item.parent();
              var accordion = $(parentNode).find("#" + $placeholder.attr("id"));
              if (accordion !== null && accordion.length >= 1) {
                playerInstance.stop();
              }
            });

            playerInstance.on("all", function () {
              $timeout(function () {
                $scope.internal.playerInfo.state = playerInstance.getState();
              });
            });

            playerInstance.on("error", function () {
              // Avoid flash-of-error due to Angular digest cycle timing
              if ($scope.internal.hideOnError) {
                $element.find(".jwplayer").addClass("ng-hide");
              }

              $scope.internal.error = true;
            });
          };

          init();
        },
      };
    },
  ]);
})(window.angular, window.document);
